module.exports = __webpack_public_path__ + "static/img/fonteProtoboard-1.06645e1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/fonteProtoboard-1.svg
// module id = oN/w
// module chunks = 0